var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'c-block-list-contact-person-custom',
		'w-5col max-w-full mx-auto',
		{
			'>=768:w-6col': _vm.contactpersons && _vm.contactpersons.length <= 1,
			'c-block-list-contact-person-custom--wide >=768:w-12col':
				_vm.contactpersons &&
				_vm.contactpersons.length >= 2 &&
				!_vm.accordionLevel,
		} ],attrs:{"id":("contact-person-" + _vm._uid)}},[(_vm.title)?_c('LongReadTarget',{attrs:{"container-id":("contact-person-" + _vm._uid),"title":_vm.title}},[_c('BaseH2',{staticClass:"text-primary-button mb-sm",domProps:{"textContent":_vm._s(_vm.title)}})],1):_vm._e(),_vm._v(" "),_c('SwiperWrap',{ref:"sliderWrap",class:['relative '],attrs:{"move-by":1,"items-wrapper-class-names":[
			'flex u-hide-scrollbar ',
			'c-block-list-contact-person-custom__swiper ',
			'snap snap-x snap-mandatory',
			'overflow-x-auto',

			{
				'c-block-list-contact-person-custom__swiper--in-accordion px-md':
					_vm.accordionLevel,
				'px-layout-margin': !_vm.accordionLevel,
			} ]},scopedSlots:_vm._u([{key:"items",fn:function(){return [(_vm.contactpersons && _vm.contactpersons.length > 0)?_c('div',{class:[
					'flex <1024:gap-x-16 flex-grow justify-center',
					{ 'gap-x-layout-gutter': !_vm.accordionLevel },
					{ 'gap-x-8': _vm.accordionLevel } ]},_vm._l((_vm.contactpersons),function(contactperson,index){return _c('div',{key:index,class:[
						'bg-primary-button w-2col text-white rounded-lg p-md flex flex-grow  <1024:flex-col  ',
						{
							'flex-col':
								_vm.contactpersons.length > 2 ||
								(_vm.accordionLevel &&
									_vm.contactpersons.length >= 2),
						} ],style:({
						minWidth: !_vm.accordionLevel ? '271px' : '247px',
					})},[(contactperson.image)?_c('UmbracoImageExt',{class:[
							'rounded-full overflow-hidden <1024:mb-32 <1024:mx-auto c-block-list-contact-person-custom__image  ',
							{
								'mb-32 mx-auto':
									_vm.contactpersons.length > 2 ||
									(_vm.contactpersons.length >= 2 &&
										_vm.accordionLevel),
								'mr-40':
									(_vm.contactpersons.length <= 2 &&
										!_vm.accordionLevel) ||
									_vm.contactpersons.length < 2,
								'c-block-list-contact-person-custom__image--in-accordion':
									_vm.accordionLevel,
							} ],attrs:{"alt":contactperson.image.altText,"widths":[320, 480, 768, 480 * 2, 768 * 2],"source-width":contactperson.image.width,"source-height":contactperson.image.height,"aspect-ratio":1,"source-url":contactperson.image.cropUrl ||
							contactperson.image.url,"image-class-names":"object-cover"}}):_c('div',[(
								_vm.contactpersons.some(
									function (contactperson) { return contactperson.image; }
								)
							)?_c('div',{class:[
								'rounded-full  bg-primary-button-hover <1024:mb-32 <1024:mx-auto c-block-list-contact-person-custom__image',
								{
									'mb-32  mx-auto':
										_vm.contactpersons.length > 2,
									'mr-40 ':
										_vm.contactpersons.length <= 2 &&
										!_vm.accordionLevel,
									'c-block-list-contact-person-custom__image--in-accordion':
										_vm.accordionLevel,
								} ]}):void 0],2),_vm._v(" "),_c('div',{staticClass:"flex flex-col break-words >=768:w-7/12"},[_c('span',{staticClass:"uppercase text-h8"},[_vm._v(_vm._s(contactperson.title))]),_vm._v(" "),_c('BaseH3',{staticClass:"mt-8 mb-16 c-overide-accordion-color"},[_vm._v(_vm._s(contactperson.name))]),_vm._v(" "),(contactperson.phone)?_c('a',{staticClass:"\n\t\t\t\t\t\t\t\tmt-16\n\t\t\t\t\t\t\t\tflex\n\t\t\t\t\t\t\t\titems-center\n\t\t\t\t\t\t\t\tw-fit\n\t\t\t\t\t\t\t\thover:underline\n\t\t\t\t\t\t\t",attrs:{"href":("tel:" + (contactperson.phone))}},[_c('SvgPhoneIcon',{staticClass:"w-12 h-12 mr-12"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(contactperson.phone))])],1):_vm._e(),_vm._v(" "),(contactperson.mobile)?_c('a',{staticClass:"\n\t\t\t\t\t\t\t\tmt-16\n\t\t\t\t\t\t\t\tflex\n\t\t\t\t\t\t\t\titems-center\n\t\t\t\t\t\t\t\tw-fit\n\t\t\t\t\t\t\t\thover:underline\n\t\t\t\t\t\t\t",attrs:{"href":("tel:" + (contactperson.mobile))}},[_c('SvgMobileIcon',{staticClass:"w-12 h-12 mr-12"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(contactperson.mobile))])],1):_vm._e(),_vm._v(" "),(contactperson.email)?_c('a',{staticClass:"\n\t\t\t\t\t\t\t\tmt-16\n\t\t\t\t\t\t\t\tflex\n\t\t\t\t\t\t\t\titems-baseline\n\t\t\t\t\t\t\t\tw-fit\n\t\t\t\t\t\t\t\thover:underline\n\t\t\t\t\t\t\t",attrs:{"href":("mailto:" + (contactperson.email))}},[_c('span',[_c('SvgMailIcon',{staticClass:"w-12 h-12 mr-12"})],1),_vm._v(" "),_c('span',{staticClass:"break-all"},[_vm._v(_vm._s(contactperson.email))])]):_vm._e(),_vm._v(" "),(
								contactperson.website &&
								contactperson.website[0]
							)?_c('NuxtLinkExt',{staticClass:"block w-fit",attrs:{"to":contactperson.website[0].url,"target":contactperson.website[0].target}},[_c('BaseButton',{staticClass:"w-fit mt-md",attrs:{"tag":"div","outline":"white-1"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.titles.buttonTitle))]},proxy:true}],null,true)})],1):_vm._e()],1)],1)}),0):_vm._e()]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }